<script setup>
import SearchIcon from '@/assets/icons/search.svg';

defineOptions({ inheritAttrs: false });

defineProps({
  modelValue: { type: String, required: true },
  label: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="sport-live-tv-search-field">
    <SearchIcon class="sport-live-tv-search-field__icon" aria-hidden="true" />
    <input
      class="sport-live-tv-search-field__input"
      :aria-label="label"
      :placeholder="label"
      :value="modelValue"
      autocomplete="off"
      v-bind="$attrs"
      @input="emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-search-field {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  border: 1px solid rgba($white, 0.1);
  border-radius: 6px;
  background-color: $black30;
  transition: border-color 0.2s ease-in-out;

  &:focus-within {
    border-color: $bg-red;
  }

  &__icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    opacity: 0.6;
  }

  &__input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    background: transparent;
    color: $white;
    font-family: inherit;
    font-size: 13px;
    outline: none;

    &::placeholder {
      color: $gray;
    }
  }
}
</style>
